import { render, staticRenderFns } from "./groupContrast.vue?vue&type=template&id=37268488&scoped=true"
import script from "./groupContrast.vue?vue&type=script&lang=js"
export * from "./groupContrast.vue?vue&type=script&lang=js"
import style0 from "./groupContrast.vue?vue&type=style&index=0&id=37268488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37268488",
  null
  
)

export default component.exports